import Modal from 'smg/modal';

export const $submit = document.querySelector('#free-quote-submit') as HTMLButtonElement;

export const $sidebarQty = document.querySelector('#free-quote-sidebar-qty') as HTMLElement;
export const $sidebarUnitPrice = document.querySelector('#free-quote-sidebar-unit-price') as HTMLElement;
export const $sidebarMoldFee = document.querySelector('#free-quote-sidebar-mold-fee') as HTMLElement;
export const $sidebarTotal = document.querySelector('#free-quote-sidebar-total') as HTMLElement;

export const $moldFeeHelp = document.querySelector('#free-quote-mold-fee-help') as HTMLElement;

export const $previewAntiqueCopper = document.querySelector<HTMLElement>('.free-quote-preview-antique-copper');
export const $previewAntiqueGold = document.querySelector<HTMLElement>('.free-quote-preview-antique-gold');
export const $previewAntiqueSilver = document.querySelector<HTMLElement>('.free-quote-preview-antique-silver');
export const $previewBlackMetal = document.querySelector<HTMLElement>('.free-quote-preview-black-metal');
export const $previewBlackNickel = document.querySelector<HTMLElement>('.free-quote-preview-black-nickel');
export const $previewCoatedWhite = document.querySelector<HTMLElement>('.free-quote-preview-coated-white');
export const $previewCopper = document.querySelector<HTMLElement>('.free-quote-preview-copper');
export const $previewGold = document.querySelector<HTMLElement>('.free-quote-preview-gold');
export const $previewRainbow = document.querySelector<HTMLElement>('.free-quote-preview-rainbow');
export const $previewSilver = document.querySelector<HTMLElement>('.free-quote-preview-silver');
export const $previewDomesticSilver = document.querySelector<HTMLElement>('.free-quote-preview-domestic-silver');
export const $previewDomesticGold = document.querySelector<HTMLElement>('.free-quote-preview-domestic-gold');
export const $previewAntiqueBrass = document.querySelector<HTMLElement>('.free-quote-preview-domestic-brass');
export const $previewAntiqueSteel = document.querySelector<HTMLElement>('.free-quote-preview-domestic-steel');

export const $previewEnamel = document.querySelector<HTMLElement>('.free-quote-preview-enamel');
export const $previewTranslucent = document.querySelector<HTMLElement>('.free-quote-preview-translucent');
export const $previewGlitter = document.querySelector<HTMLElement>('.free-quote-preview-glitter');
export const $previewDomesticDieStruckColor = document.querySelector<HTMLElement>('.free-quote-preview-domestic-diestruck-color');
export const $previewDomesticSimEnamel = document.querySelector<HTMLElement>('.free-quote-preview-domestic-sim-enamel');

$moldFeeHelp?.addEventListener('click', e => {
    e.preventDefault();

    new Modal({
        title: 'What\'s a Mold Fee?',
        text: `Think of it like the setup cost for your custom creation!
            This one-time fee covers the creation of the mold used to stamp
            your unique design during production. Once paid, it's good for two
            years and reordering resets the clock, keeping your future orders mold-fee free`,
        width: '596px',
        appendClassBySelector: {
            '.modal-content': 'p-8 pt-0',
            '.modal-header': 'border-bottom-0 p-0',
            '.modal-title': 'text-center fs-2 w-100 p-0 mt-8',
            '.modal-footer': 'd-none',
        },
    });
});

export function SetPlating(plating: string) {
    $previewAntiqueCopper?.classList.add('d-none');
    $previewAntiqueGold?.classList.add('d-none');
    $previewAntiqueSilver?.classList.add('d-none');
    $previewBlackMetal?.classList.add('d-none');
    $previewBlackNickel?.classList.add('d-none');
    $previewCoatedWhite?.classList.add('d-none');
    $previewCopper?.classList.add('d-none');
    $previewGold?.classList.add('d-none');
    $previewRainbow?.classList.add('d-none');
    $previewSilver?.classList.add('d-none');
    $previewDomesticSilver?.classList.add('d-none');
    $previewDomesticGold?.classList.add('d-none');
    $previewAntiqueBrass?.classList.add('d-none');
    $previewAntiqueSteel?.classList.add('d-none');

    switch (plating) {
    case 'Antique Copper':
        $previewAntiqueCopper?.classList.remove('d-none');
        break;
    case 'Antique Gold':
        $previewAntiqueGold?.classList.remove('d-none');
        break;
    case 'Antique Silver':
        $previewAntiqueSilver?.classList.remove('d-none');
        break;
    case 'Black Metal':
        $previewBlackMetal?.classList.remove('d-none');
        break;
    case 'Black Nickel':
        $previewBlackNickel?.classList.remove('d-none');
        break;
    case 'Coated White':
        $previewCoatedWhite?.classList.remove('d-none');
        break;
    case 'Copper':
        $previewCopper?.classList.remove('d-none');
        break;
    case 'Gold':
        $previewGold?.classList.remove('d-none');
        break;
    case 'Rainbow':
        $previewRainbow?.classList.remove('d-none');
        break;
    case 'Silver':
        $previewSilver?.classList.remove('d-none');
        break;
    case 'Domestic Silver':
        $previewDomesticSilver?.classList.remove('d-none');
        break;
    case 'Domestic Gold':
        $previewDomesticGold?.classList.remove('d-none');
        break;
    case 'Antique Brass':
        $previewAntiqueBrass?.classList.remove('d-none');
        break;
    case 'Antique Steel':
        $previewAntiqueSteel?.classList.remove('d-none');
        break;
    default:
        if (window.location.href.includes('american-made')) {
            $previewAntiqueBrass?.classList.remove('d-none');
        } else {
            $previewAntiqueCopper?.classList.remove('d-none');
        }
    }
}

export function SetUpgrade(upgrade: string, color: string) {
    if (upgrade === 'Translucent Paint') {
        $previewTranslucent?.classList.remove('d-none');
    } else if (upgrade === 'Glitter') {
        $previewGlitter?.classList.remove('d-none');
    } else if (color === 'yes') {
        $previewEnamel?.classList.remove('d-none');
    } else if (color === 'domestic-diestruck-color') {
        $previewDomesticDieStruckColor?.classList.remove('d-none');
        $previewDomesticSimEnamel?.classList.add('d-none');
    } else if (color === 'domestic-simulated-enamel') {
        $previewDomesticSimEnamel?.classList.remove('d-none');
        $previewDomesticDieStruckColor?.classList.add('d-none');
    } else if (color === 'no') {
        $previewDomesticDieStruckColor?.classList.add('d-none');
        $previewDomesticSimEnamel?.classList.add('d-none');
    }
}
